<template>
    <div>
        <az-back-button :route="{name: 'termosConfiguracao'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <az-formbar>
              <div class="hide">
                <div class="itens"></div>
                <div class="actions"></div>
              </div>
            </az-formbar>
            <termo-dados v-if="termoLocal" v-model="termoLocal" :editando="editando"/>
            <div class="az-actions-form" v-az-auth="'DeclaracoesTermos.Atualizar'">
              <div class="align-left"></div>
              <div v-if="editando" class="align-right">
                <button class="action-secundary" @click="$router.push({name: 'termosConfiguracao'})">Cancelar</button>
                <button class="action-primary" @click.prevent="salvar">Salvar</button>
              </div>
              <div v-else class="align-right">
                <button class="action-primary" @click.prevent="abrirEdicao">Editar</button>
              </div>
            </div>
        </az-container>
    </div>
</template>

<script>
    import {actionTypes} from '@/commons/constants'
    import TermoDados from "@/views/configuracao/termos/TermoDados";

    export default {
      name: 'TermoAtualizacao',
      components: {TermoDados},
      data() {
            return {
                editando: false,
                termoLocal: null,
                termoId: null
            }
        },
        async mounted() {
            this.setEditando(this.$route.query.edicao)
            this.setTermoId(this.$route.params.id)
            await this.buscarTermo()
        },
        methods: {
            async buscarTermo() {
                this.setMensagemLoading('Carregando Termo...')
                const response = await this.$store.dispatch(actionTypes.BUSCAR_TERMO_ACEITE, this.termoId)
                this.termoLocal = response.termo
            },
            setTermoId(termoId) {
                this.termoId = termoId
            },
            setEditando(editando) {
                this.editando = typeof editando !== 'undefined' && (editando.toString() === 'true')
            },
            abrirEdicao() {
                this.$router.push({name: 'termoAtualizacao', params: {id: this.termoId}, query: {edicao: true}})
            },
            abrirVisualizacao() {
                this.$router.push({name: 'termoAtualizacao', params: {id: this.termoId}})
            },
            async salvar() {
              const validado = await this.$validator._base.validateAll()
              if (!validado) {
                return
              }
              this.setMensagemLoading('Salvando termo...')
              await this.$store.dispatch(actionTypes.ATUALIZAR_TERMO_ACEITE, {termo: this.termoLocal})
              this.mostrarNotificacaoSucesso("Termo atualizado com sucesso!")
              this.abrirVisualizacao()
          }
        },
      watch:{
        '$route.query.edicao':{
            handler(novoValor){
                this.setEditando(novoValor)
            }
        }
      }
    }
</script>